import { render, staticRenderFns } from "./ParkingSettings.vue?vue&type=template&id=c21567f2&"
import script from "./ParkingSettings.vue?vue&type=script&lang=js&"
export * from "./ParkingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports